import { render } from "./DetalleFormaPago.vue?vue&type=template&id=bec29e6e&scoped=true"
import script from "./DetalleFormaPago.vue?vue&type=script&lang=js"
export * from "./DetalleFormaPago.vue?vue&type=script&lang=js"

import "./DetalleFormaPago.vue?vue&type=style&index=0&id=bec29e6e&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bec29e6e"]])

export default __exports__